import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingResizePhotoKbConfig } from '@/data/landingConfig/landingResizePhotoKbConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ResizePhotoKb } from './schemaObject';

interface Props {}
const ResizePhotoKb: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ResizePhotoKb} />
			<LandingTemplate
				data={landingResizePhotoKbConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageCompressor()}
			/>
		</>
	);
};

export default ResizePhotoKb;
